module.exports = __webpack_public_path__ + "img/icon-morning-2.abd5477d.png";